<template>
  <el-dialog
      title="患者评估"
      :append-to-body="true"
      :visible.sync="showTag"
      width="80%"
  >
    <h2 class="flex jcc">直升机转运患者评估系统</h2>
    <h3 class="">一般模块</h3>
    <h4 class="">1.预检评估系统</h4>
    <el-form ref="form" :model="form" size="mini" label-width="100px">
      <el-form-item v-for="(item,index) in yjpgxtForm" :label="item.label+'：'" :key="'1'+index">
        <template v-if="item.type==='inputGroup'">
          <div class="flex wrap">
            <staff-input v-for="(d,i) in item.value" :key="'1'+index+i" v-model="form[d.id]" :pre="d.pre" :suf="d.suf"
                         :class="d.class" :max="d.max" :min="d.min" :float="d.float"></staff-input>
          </div>
        </template>
        <staff-radio-group v-else-if="item.type==='radioGroup'" :data="item.value"
                           v-model="form[item.id]"></staff-radio-group>
      </el-form-item>
    </el-form>
    <h4>2.气道/呼吸系统</h4>
    <el-form ref="form" :model="form" size="mini" label-width="120px">
      <el-form-item v-for="(item,index) in qdhxxtForm" :label="item.label+'：'" :key="'2'+index">
        <template v-if="item.type==='inputGroup'">
          <div class="flex wrap">
            <staff-input v-for="(d,i) in item.value" :key="'2'+index+i" v-model="form[d.id]" :pre="d.pre" :suf="d.suf"
                         :class="d.class" :max="d.max" :min="d.min" :float="d.float"></staff-input>
          </div>
        </template>
        <staff-radio-group v-else-if="item.type==='radioGroup'" :data="item.value"
                           v-model="form[item.id]" @inputChange="inputChange"></staff-radio-group>
      </el-form-item>
    </el-form>
    <h3>特殊模块</h3>
    <div class="flex mt10 mb20">
      <div
          class="btn pointer fs14 pl10 pr10 mr10"
          @click="currIdx = idx"
          v-for="(btn, idx) in btnGroup"
          :key="idx"
          :class="{ isCurr: idx === currIdx }"
      >
        {{ btn.name }}
      </div>
    </div>
    <el-form ref="form" :model="form" size="mini" label-width="140px" v-if="currIdx===0">
      <el-form-item v-for="(item,index) in jxxjgsForm" :label="item.label+'：'" :key="'3'+index">
        <template v-if="item.type==='inputGroup'">
          <div class="flex wrap">
            <staff-input v-for="(d,i) in item.value" :key="'3'+index+i" v-model="form[d.id]" :pre="d.pre" :suf="d.suf"
                         :class="d.class" :max="d.max" :min="d.min"></staff-input>
          </div>
        </template>
        <staff-checkbox-group-pic v-else-if="item.type==='checkboxGroupPic'" :data="item.value"
                                  v-model="form[item.id]" :key="'3'+index"
                                  @inputChange="inputChange"></staff-checkbox-group-pic>
        <staff-checkbox-group v-else-if="item.type==='checkboxGroup'" :data="item.value"
                              v-model="form[item.id]" :key="'3'+index"
                              @inputChange="inputChange"></staff-checkbox-group>
        <template v-else-if="item.type==='diy'">
          <template v-for="(d,i) in item.value">
            <template v-if="d.type==='radioGroup'&&showFscdzg">（
              <staff-radio-group :data="d.value" :key="i"
                                 v-model="form[d.id]" @inputChange="inputChange"></staff-radio-group>
              ）
            </template>
            <staff-checkbox-group v-else-if="d.type==='checkboxGroup'" :data="d.value"
                                  v-model="form[d.id]" :key="i" @inputChange="inputChange"></staff-checkbox-group>
          </template>
        </template>
      </el-form-item>
    </el-form>
    <el-form ref="form" :model="form" size="mini" label-width="150px" v-if="currIdx===1">
      <el-form-item :label="item.label+'：'" v-for="(item,index) in xeForm" :key="'4'+index">
        <staff-radio-group :data="item.value" v-model="form[item.id]"></staff-radio-group>
      </el-form-item>
    </el-form>
    <el-form ref="form" :model="form" size="mini" label-width="100px" v-if="currIdx===2">
      <el-form-item :label="item.label+'：'" v-for="(item,index) in ssForm" :key="'5'+index">
        <staff-radio-group :data="item.value" v-model="form[item.id]"
                           v-if="item.type==='radioGroup'"></staff-radio-group>
        <template v-if="item.type==='inputGroup'">
          <div class="flex wrap">
            <staff-input v-for="(d,i) in item.value" :key="'3'+index+i" v-model="form[d.id]" :pre="d.pre" :suf="d.suf"
                         :class="d.class" :length="d.length" :input-class="d.inputClass"></staff-input>
          </div>
        </template>
      </el-form-item>
    </el-form>
    <el-form ref="form" :model="form" size="mini" label-width="100px" v-if="currIdx===3">
      <el-form-item v-for="(item,index) in csForm" :key="'6'+index" :label="item.label+'：'">
        <template v-if="item.type==='diy'">
          <p v-for="(d,i) in item.value" :key="'6'+index+i">
            <template v-if="d.type==='inputGroup'">
              <div class="flex wrap">
                <staff-input v-for="(dd,ii) in d.value" :key="'6'+index+ii" v-model="form[dd.id]" :pre="dd.pre"
                             :suf="dd.suf"
                             :class="dd.class" :length="dd.length" :input-class="dd.inputClass"></staff-input>
              </div>
            </template>
            <staff-checkbox-group @inputChange="inputChange" class="flex0" :id="d.id" :data="d.value"
                                  v-model="form[d.id]" v-if="d.type==='checkboxGroup'"></staff-checkbox-group>
          </p>
        </template>
        <template v-if="item.type==='radioGroupArray'">
          <p v-for="(d,i) in item.value" :key="'6'+index+i" class="flex">
            <span class="flex0">{{ d.label }}（</span>
            <staff-checkbox-group class="flex0" :id="d.id" :data="d.value"
                                  v-model="form[d.id]" v-if="d.type==='checkboxGroup'"></staff-checkbox-group>
            <staff-radio-group :data="d.value"
                               v-model="form[d.id]" v-else></staff-radio-group>
            <span class="flex0">）</span>
          </p>
        </template>
        <staff-checkbox-group v-if="item.type==='checkboxGroup'" :data="item.value"
                              v-model="form[item.id]" @inputChange="inputChange"></staff-checkbox-group>
      </el-form-item>
    </el-form>
    <el-form ref="form" :model="form" size="mini" label-width="120px" v-if="currIdx===4">
      <h2 class="mb20">NIHSS评分风险评估（7~22分）：共<input class="w60" v-model="form.nihssScoringRiskAssessment"
                                                  style="border: none 0px; border-bottom: 1px solid #ccc; padding: 0px 5px; outline: none;font-size: 24px;text-align: center;"/>分
      </h2>
      <el-form-item v-for="(item,index) in zzForm" :key="'7'+index" :label="item.label+'：'">
        <staff-radio-group v-if="item.type==='radioGroup'" :data="item.value"
                           v-model="form[item.id]"></staff-radio-group>
        <template v-if="item.type==='inputGroup'">
          <div class="flex">
            <staff-input v-for="(d,i) in item.value" :key="'7'+index+i" :max="d.max" :min="d.min"
                         v-model="form[d.id]" :suf="d.suf" :pre="d.pre"></staff-input>
          </div>
        </template>
      </el-form-item>
    </el-form>
    <div class="flex jcc pt20 pb20">
      <el-button type="primary" @click="submit">保&nbsp;&nbsp;&nbsp;&nbsp;存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import StaffInput from "@/modules/staff/components/staff-input";
import StaffRadioGroup from "@/modules/staff/components/staff-radio-group";
import {
  PG_FORM_DATA,
  PG_FORM_FIELDS,
  yjpgxtForm,
  qdhxxtForm,
  jxxjgsForm,
  xeForm,
  ssForm,
  csForm,
  zzForm
} from "@/modules/staff/config";
import {staffService} from "@/modules/staff/service/staff";
import {STAFF_ADD_PG, STAFF_EDIT_PG} from "@/modules/staff/events";
import {handlerTrauma} from "@/modules/staff/filter";
import StaffCheckboxGroup from "@/modules/staff/components/staff-checkbox-group";
import StaffCheckboxGroupPic from "@/modules/staff/components/staff-checkbox-group-pic";

export default {
  name: "add-pg-form-dialog",
  components: {StaffCheckboxGroupPic, StaffCheckboxGroup, StaffRadioGroup, StaffInput},
  props: {
    info: {
      type: Object,
      default: () => Object.create(null)
    },
  },
  data() {
    const btnArr = [
      "急性心肌梗死",
      "小儿",
      "烧伤",
      "创伤",
      "卒中"
    ];
    const makeBtnGroup = arr => {
      return [...arr].map(r => ({
        name: r
      }));
    };
    let form = {};
    for (let key in PG_FORM_FIELDS) {
      form[key] = '';
    }
    return {
      showTag: false,
      pgFormData: PG_FORM_DATA,
      yjpgxtForm, qdhxxtForm, jxxjgsForm, xeForm, ssForm, csForm, zzForm,
      originForm: {},
      form: form,
      currIdx: 0,
      btnGroup: makeBtnGroup(btnArr)
    }
  },
  computed: {
    showFscdzg() {
      let val = this.form.electrocardiogramDiagnosis || [];
      return val.includes(8)
    }
  },
  created() {
    // 创伤评估处理
    csForm[2].value.forEach(r => {
      if (r.type === 'checkboxGroup')
        this.$watch(`form.${r.id}`, (newV) => {
          this.handlerZc(r.id, newV);
        })
    })

    jxxjgsForm[1].value.forEach((r, i) => {
      this.$watch(`form.${r.id}`, (newV) => {
        Log(r.id, newV);
        if (newV) {
          !this.form.bloodConditionMonitoring.includes(i) && this.form.bloodConditionMonitoring.push(i);
        }
      })
    })
  },
  watch: {
    // 血液状态检测
    /*'form.bloodConditionMonitoring': {
      handler(newV, oldV) {
        Log('bloodConditionMonitoring', newV, oldV, jxxjgsForm[1].value);
        jxxjgsForm[1].value.forEach((r, i) => {
          if (!newV.includes(i)) {
            this.$set(r, 'data', '');
            this.$set(this.form, r.id, '');
          }
        })
      }
    }*/
  },
  methods: {
    /**
     * 创伤评估，带有正常选项处理
     */
    handlerZc(id, val) {
      if (val && val.length) {
        const last = val[val.length - 1];
        if (last === 0)
          this.$nextTick(() => {
            while (this.form[id].length > 1) {
              this.form[id].shift();
            }
          })
        else {
          let index = val.indexOf(0);
          if (index >= 0) {
            this.$nextTick(() => {
              this.form[id].splice(index, 1);
            })
          }
        }
      }
    },
    show(id) {
      if (id) {
        this.$set(this.form, 'id', id);
        this.getDetail();
      } else {
        delete this.form.id;
      }
      this.showTag = true;
    },
    hide() {
      this.showTag = false;
    },
    async getDetail() {
      const detail = await staffService.pgDetail(this.info.id);
      this.originForm = detail;
      const {yjpgxtForm, qdhxxtForm, jxxjgsForm, xeForm, ssForm, csForm, zzForm} = this;
      if (detail.nihssScoringRiskAssessment) this.$set(this.form, 'nihssScoringRiskAssessment', detail.nihssScoringRiskAssessment);
      const handler = r => {
        if (r.type === 'inputGroup') {
          r.value.forEach(rr => {
            if (detail[rr.id]) this.$set(this.form, rr.id, detail[rr.id])
          });
        }
        if (r.type === 'radioGroup') {
          if (detail[r.id]) this.$set(this.form, r.id, parseInt(detail[r.id]));
          r.value.forEach(rr => {
            if (rr.id) {
              detail[rr.id] && this.$set(rr, 'data', detail[rr.id]);
            }
          })
        }

        //上传图片单独处理
        if (r.type === 'checkboxGroupPic') {
          let data = detail[r.id];
          if (data) {
            data = data.split('-');
            this.$set(this.form, r.id, data.map(r => parseInt(r)));
          }
          r.value.forEach(rr => {
            detail[rr.id] && this.$set(this.form, rr.id, detail[rr.id]);
          });
        }

        if (r.type === 'checkboxGroup') {
          let data = detail[r.id];
          if (data) {
            data = data.split('-');
            this.$set(this.form, r.id, data.map(rr => parseInt(rr)));
          }
        }

        if (r.type === 'diy') {
          r.value.forEach(rr => {
            if (rr.type === 'checkboxGroup') {
              let data = detail[rr.id];
              if (data) {
                data = data.split('-');
                this.$set(this.form, rr.id, data.filter(r => /\d/.test(r)).map(r => parseInt(r)));
              }
            }
            if (rr.type === 'radioGroup') {
              if (detail[rr.id]) this.$set(this.form, rr.id, parseInt(detail[rr.id]));
            }
            if (rr.type === 'inputGroup') {
              rr.value.forEach(rrr => {
                if (detail[rrr.id]) this.$set(this.form, rrr.id, detail[rrr.id])
              });
            }

          })
        }

        if (r.type === 'radioGroupArray') {
          r.value.forEach(rr => {
            if (rr.type === 'checkboxGroup') {
              let data = detail[rr.id];
              if (data) {
                data = data.split('-');
                this.$set(this.form, rr.id, data.map(rrr => parseInt(rrr)));
              }
            } else {
              if (detail[rr.id]) this.$set(this.form, rr.id, parseInt(detail[rr.id]));
            }
          })
        }


        if (r.id === 'trauma') {
          this.$set(this.form, 'trauma', handlerTrauma(detail.trauma, 'detail'));
        }
      }

      yjpgxtForm.forEach(handler);
      qdhxxtForm.forEach(handler);
      jxxjgsForm.forEach(handler);
      xeForm.forEach(handler);
      ssForm.forEach(handler);
      csForm.forEach(handler);
      zzForm.forEach(handler);
      /*for (let key in PG_FORM_FIELDS) {
        if (detail[key]) {
          this.$set(this.form, key, detail[key]);
        }
      }
      for (let key in PG_FORM_DATA) {
        if (Array.isArray(PG_FORM_DATA[key])) {
          for (let {id} of PG_FORM_DATA[key]) {
            this.$set(this.form, id, detail[id] || undefined);
          }
        } else {
          let {id, extra} = PG_FORM_DATA[key];
          if (extra && extra.length) {
            this.pgFormData[key].extra = extra.map(r => {
              return {
                ...r,
                value: detail[r.field]
              }
            });
          }
          if (detail[id])
            this.$set(this.form, id, detail[id]);
          if (id === 'trauma')
            this.$set(this.form, id, handlerTrauma(detail[id], 'detail'));
        }
      }*/
    },

    inputChange(data) {
      Log('inputChange', data);
      for (let key in data) {
        this.$set(this.form, key, data[key]);
      }
    },

    async submit() {
      let options = {...this.form};
      for (let key in options) {
        if (Array.isArray(options[key]))
          options[key] = options[key].join('-');
      }
      if (await staffService.pg({
        emergencyReferralOrderId: this.info.id,
        ...options,
        trauma: options.trauma === 1 ? false : true
      })) {
        this.hide();
        if (this.form.id) {
          bus.$emit(STAFF_EDIT_PG.id, STAFF_EDIT_PG.name)
        } else {
          bus.$emit(STAFF_ADD_PG.id, STAFF_ADD_PG.name)
        }
      }
    }
  },
}
</script>

<style scoped lang="scss">
.btn {
  border: 1px solid #dcdfe6;
  border-radius: 2px;
  line-height: 30px;

  &.isCurr {
    color: #3692f9;
    background: #e6f1fc;
    border: 1px solid #a3d0fd;
    border-radius: 2px;
  }
}

h3, h4 {
  font-size: 18px;
  padding-top: 5px;
  padding-bottom: 5px;
}

h4 {
  font-size: 16px;
}

</style>